import { render, staticRenderFns } from "./JoinedCompaignVI.vue?vue&type=template&id=5b1a57cc&scoped=true"
import script from "./JoinedCompaignVI.vue?vue&type=script&lang=js"
export * from "./JoinedCompaignVI.vue?vue&type=script&lang=js"
import style0 from "./JoinedCompaignVI.vue?vue&type=style&index=0&id=5b1a57cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a57cc",
  null
  
)

export default component.exports